export default "__VITE_ASSET__a85eb5b2__"